import { motion } from 'framer-motion';
import { AnimTap } from 'libs/styles/styling';
import { setCookie } from 'libs/utils/logic/operations/storageOperations';
import { useContext } from 'react';
import { CtxApp } from 'session/ctxApp';
import { LOCAL_STORAGE_LANGUAGE } from 'static/config/coreConfig';
import { languages } from 'static/config/language/languageConfig';
import { FlagCs } from 'static/flags/flag_cs';
import { FlagEn } from 'static/flags/flag_en';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const LanguageSwitch = (props: Props): JSX.Element => {
    const ctxApp = useContext(CtxApp);

    function changeLanguage(langCode: string) {
        const lang = languages.find((e) => e.code === langCode);
        if (!lang) {
            return;
        }
        setCookie(LOCAL_STORAGE_LANGUAGE, lang.code);
        Localization.setLanguage(lang.code);
        ctxApp.setLanguage(lang.code);

        // window.location.reload();
    }

    return (
        <S_LanguageSwitch className={props.className}>
            <S_Link
                onClick={() => {
                    changeLanguage('en');
                }}
                {...AnimTap}
            >
                <FlagEn height={18} />
            </S_Link>
            <S_Link
                onClick={() => {
                    changeLanguage('cs');
                }}
                {...AnimTap}
            >
                <FlagCs height={18} />
            </S_Link>
        </S_LanguageSwitch>
    );
};

const S_Link = styled(motion.div)`
    display: flex;
    cursor: pointer;
`;

const S_LanguageSwitch = styled.div`
    display: flex;
    width: auto;
    justify-content: center;
    width: 100%;
    ${S_Link}:not(:last-child) {
        margin: 0 25px 0 0;
    }
`;
